import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import constants from '@src/constants';
import ApiActions from '@src/action/ActionFactory';

import * as actions from './actions';
import EmbedDisplay from './EmbedDisplay';

import { getCCAndCountry, getRestrictionFilter } from './selector';

const mapStateToProps = state => {
  const selectedCC = getCCAndCountry(state);
  const restrictions = getRestrictionFilter(state);

  const getDomain = () => {
    const host = window.location.hostname;
    // return host without . (dot)
    return host.substr(host.indexOf('.') + 1);
  };

  let yfhost = constants.YF_HOST;
  // if (__ENV__ === 'production') {
  //   yfhost = `${constants.YF_PROTOCOLS}://${
  //     constants.YF_SUBDOMAIN
  //   }.${getDomain()}/`;
  // }

  return {
    yfhost,
    status: state.yellowfin.yfsso.status,
    token: state.yellowfin.yfsso.token,
    isFetching: state.yellowfin.isFetching,
    companyCode: selectedCC.costcenter,
    countryCode: selectedCC.country.value,
    restrictions,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  apiActions: bindActionCreators(ApiActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmbedDisplay);



// WEBPACK FOOTER //
// ./src/features/yellowfin/EmbedDisplayContainer.js